import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=112ee3fb&scoped=true"
import script from "./Books.vue?vue&type=script&lang=js"
export * from "./Books.vue?vue&type=script&lang=js"
import style0 from "./Books.vue?vue&type=style&index=0&id=112ee3fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112ee3fb",
  null
  
)

export default component.exports